import {TypeImplementation, withSystem} from '@packages/systems/wfdl';
import {functionOf, TText, TListOfElement} from '@packages/systems/wfdl-ast';
import {qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {pluginName} from '../constants';
import {
  dynamoTextualContentToListOfElements,
  dynamoTextualContentToText,
} from '../transformers';
import {TOption} from '@packages/systems/plugins/Option';
import {TBasicLink} from '../Link';
import type {DynamoEnvValueType} from '../types';
import {createDynamoTextOperators} from '../utils';
import {TDynamoPhone} from '@packages/systems/plugins-utils/DynamoGateway';

export const PhoneType = TypeImplementation.Custom({
  render: () => null,
  icon: TypeImplementation.IconByName(qualify(pluginName, iconName('Phone'))),
});

export const dynamoPhoneToText = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoPhone)),
      TText
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: dynamoTextualContentToText,
} as const;

export const dynamoPhoneToListOfElements = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoPhone)),
      TListOfElement
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: dynamoTextualContentToListOfElements,
} as const;

type PhoneLinkLiteral = {
  tel: string;
  mode: 'tel';
};

export const dynamoPhoneToBasicLink = {
  envType: {
    dataType: functionOf(
      withSystem({isBindable: true}, TOption(TDynamoPhone)),
      TBasicLink
    ),
    exported: 'visible',
    implicit: 'prefilledArgs',
  },
  value: (option: DynamoEnvValueType<string>): PhoneLinkLiteral => {
    if (option === null || option.tag === 'None') {
      return {
        tel: '',
        mode: 'tel',
      };
    }

    return {
      tel: option.val,
      mode: 'tel',
    };
  },
} as const;

// Generate all text-based operators using the generic utility function
const phoneOperators = createDynamoTextOperators(TDynamoPhone);

export const dynamoPhoneEquals = phoneOperators.equals;
export const dynamoPhoneDoesNotEqual = phoneOperators.doesNotEqual;
export const dynamoPhoneContains = phoneOperators.contains;
export const dynamoPhoneDoesNotContain = phoneOperators.doesNotContain;
export const dynamoPhoneStartsWith = phoneOperators.startsWith;
export const dynamoPhoneDoesNotStartWith = phoneOperators.doesNotStartWith;
export const dynamoPhoneEndsWith = phoneOperators.endsWith;
export const dynamoPhoneDoesNotEndWith = phoneOperators.doesNotEndWith;
export const dynamoPhoneIsSet = phoneOperators.isSet;
export const dynamoPhoneIsNotSet = phoneOperators.isNotSet;
export const dynamoPhoneOperand = phoneOperators.operand;
